import React from 'react';

export default ({ url = '', ...props }) => (
  <audio className="audio has-text-danger" controls>
    <source src={url} type={`audio/${url.slice(-3)}`} />
    Browser does not support audio tag
    <code>audio</code>
  </audio>
);
